import { useFrappeGetDocList } from 'frappe-react-sdk'
import classNames from 'classnames'
import React from 'react'
import SfSelect from '../Select'

const BranchSelect = ({
    name,
    onChange,
    value,
    error,
    ...props
}) => {
    const { data: branchList, error: fetchError } = useFrappeGetDocList("Branch", {
        fields: ["*"]
    })
    return (
        <>
            <SfSelect size="base" name={name} onChange={onChange} value={value}>
                <option value="">เลือกสาขา</option>
                {(branchList ?? []).map((branch) => (
                    <option value={branch.name} key={branch.name}>
                        {branch.name}
                    </option>
                ))}
            </SfSelect>
            {
                error && <p className="text-negative-600">กรุณาเลือกสาขา</p>
            }
            {
                fetchError && !branchList && (
                    <p className="text-negative-600 text-sm mt-1">ไม่สามารถโหลดรายชื่อสาขาได้ กรุณาเข้าสู่ระบบอีกครั้ง</p>
                )
            }
        </>
    )
}

export default BranchSelect